"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _settings = require("./settings");

var _Collapse = _interopRequireDefault(require("../Collapse/Collapse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollapsibleNotification = function CollapsibleNotification(_ref) {
  var transitionTime = _ref.transitionTime,
      transitionCloseTime = _ref.transitionCloseTime,
      easing = _ref.easing,
      isOpen = _ref.isOpen,
      isLazyRender = _ref.isLazyRender,
      openedClassName = _ref.openedClassName,
      collapsedClassName = _ref.collapsedClassName,
      triggerClosedClassName = _ref.triggerClosedClassName,
      triggerOpenedClassName = _ref.triggerOpenedClassName,
      trigger = _ref.trigger,
      triggerWhenOpen = _ref.triggerWhenOpen,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      type = _ref.type,
      className = _ref.className,
      icon = _ref.icon,
      size = _ref.size,
      align = _ref.align,
      children = _ref.children;
  return _react.default.createElement(_Collapse.default, {
    transitionTime: transitionTime,
    transitionCloseTime: transitionCloseTime,
    easing: easing,
    isOpen: isOpen,
    isLazyRender: isLazyRender,
    openedClassName: openedClassName,
    collapsedClassName: collapsedClassName,
    triggerClosedClassName: triggerClosedClassName,
    triggerOpenedClassName: triggerOpenedClassName,
    trigger: trigger,
    triggerWhenOpen: triggerWhenOpen,
    onOpen: onOpen,
    onClose: onClose
  }, _react.default.createElement(_Notification.default, {
    type: type,
    className: className,
    visible: true,
    icon: icon,
    size: size,
    align: align
  }, children));
};

CollapsibleNotification.defaultProps = {
  transitionTime: 500,
  easing: 'ease-out',
  isOpen: false
};
CollapsibleNotification.propTypes = {
  /**
   * The type of notification component (Warning, Information, Error, Success)
   */
  type: _propTypes.default.oneOf(_settings.notificationTypeList).isRequired,

  /**
   * Css classes that can get applied to the component
   */
  className: _propTypes.default.string,

  /**
   * Child components that will get rendered in the notification
   */
  children: _propTypes.default.node,

  /**
   * Determines whether an icon should be visible or not
   */
  icon: _propTypes.default.bool,

  /**
   * Change the size of the notification
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * Change the alignment of components inside the notification
   */
  align: _propTypes.default.oneOf(['center', 'bottom']),

  /**
   * The time in milliseconds it takes to collapse the notification. Defaults to 500ms
   */
  transitionTime: _propTypes.default.number,

  /**
   * The number of milliseconds for the close transition to take. Defaults to transitionTime
   */
  transitionCloseTime: _propTypes.default.number,

  /**
   * The CSS easing method you wish to apply to the open/close transition.
   * This string can be any valid value of CSS transition-timing-function.
   * Defaults to ease-out
   * For reference view the MDN documentation https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function.
   */
  easing: _propTypes.default.string,

  /**
   * Determines whether the component to renders in the open state. Defaults to false
   */
  isOpen: _propTypes.default.bool,

  /**
   * Set this to true to postpone rendering of all of the content of the component
   * until before it's opened for the first time. Defaults to false
   */
  isLazyRender: _propTypes.default.bool,

  /**
   * Add this class name to the root element when the component is opened
   */
  openedClassName: _propTypes.default.string,

  /**
   * Add this class name to the root element when the component is collapsed
   */
  collapsedClassName: _propTypes.default.string,

  /**
   * Css classes that will be applied to the trigger when the component is collapsed
   */
  triggerClosedClassName: _propTypes.default.string,

  /**
   * Css classes that will be applied to the trigger when the component is open
   */
  triggerOpenedClassName: _propTypes.default.string,

  /**
   * The link which when clicked opens the collapsable area
   */
  trigger: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,

  /**
   * Trigger text or element to change to when the component is open
   */
  triggerWhenOpen: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * A function that is called when the component has been opened and the animation is finished
   */
  onOpen: _propTypes.default.func,

  /**
   * A function that is called when the component has finished collapsing
   */
  onClose: _propTypes.default.func
};
var _default = CollapsibleNotification;
exports.default = _default;